const styles = theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: '#002940',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 9999
  },
  alert: {
    alignItems: 'center',
    color: `${theme.palette.error.main} !important`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%'
  },
  icon: {
    color: theme.palette.primary.main,
    height: 80,
    marginBottom: theme.spacing.unit * 5,
    width: 80
  },
  error: {
    color: '#FFFFFF !important',
    marginBottom: `${theme.spacing.unit * 3}px !important`
  },
  message: {
    color: `rgba(255,255,255,0.6) !important`,
    letterSpacing: '0 !important',
    lineHeight: `24px !important`,
    textAlign: 'center',
    width: 311
  },
  logo: {
    position: 'absolute',
    top: theme.spacing.unit * 4
  }
});

export default styles;
